/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CareersManagementDash from "../../components/CareersManagement";
import Navbar from "../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../constants/routes";

const CareersManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};

  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.careers?.hasAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <CareersManagementDash userConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CareersManagement;
